var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.len.length > 0)?_c('el-badge',{staticClass:"item",attrs:{"value":_vm.len.length,"type":_vm.getType}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }